exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-splash__logo{width:200px}.page-splash__description{margin:30px 0}.page-splash__meer-uitleg{font-size:.8em;border-left:1px solid;border-right:1px solid;padding:15px;margin-top:30px}.page-splash__main-icon{border-radius:50%;padding:20px;background-color:#fff;display:inline-block}.page-splash__main-icon-img{position:relative;top:5px;background-image:url(" + require("../../assets/images/hybride-man-150.png") + ");background-size:contain;background-repeat:no-repeat;background-position:50%;padding:10px;width:100px;height:100px}.page-splash__scroll-message{font-family:Helvetica;font-size:.8em;display:block}.page-splash__hier-btn{cursor:pointer;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46ef308d","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-splash.vue
// module id = 60
// module chunks = 0